// Copyright (C) 2019 Berkadia Commercial Mortgage, LLC - All Rights Reserved

import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Button from '@material-ui/core/Button'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormLabel from '@material-ui/core/FormLabel'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import CloseIcon from '@material-ui/icons/Close'
import Comps from '@engine/comps'
import { connect } from 'react-redux'
import './SaveProjectDialog.scss'

const useStyles = makeStyles(theme => ({
    root: {
        padding: 'unset'
    },
    formControlRoot: {
        width: '342px',
        height: '48.7px',
        marginLeft: '8px'
    },
    portfolioformControlRoot: {
        width: '342px',
        marginLeft: '8px',
        marginTop: '20px'
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    },
    paperScrollPaper: {
        width: '395px',
        height: '485px',
        padding: '16px',
        borderRadius: '8px'
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  }))

function SaveProjectDialog(props) {
    const classes = useStyles()
    const initialState = { dealNumber: props.dealNumber, office: props.office, isPortfolio: props.isPortfolio }
    const inputLabel = React.useRef(null)
    const [saveProjectAttrib, setSaveProjectAttributes] = React.useState({ ...initialState })
    const { SaveProjectDialogOpen, handleDialog, regions } = props
    const handleCancel = () => {
        setSaveProjectAttributes({ ...initialState })
        handleDialog('cancel')
    }

    return (
        <Dialog
            open={SaveProjectDialogOpen}
            aria-labelledby="save-dialog-title"
            aria-describedby="save-dialog-description"
            data-testid="save-comps-project-dialog"
            classes={{ paperScrollPaper: classes.paperScrollPaper }}
        >
            <div className="save_header_dialog">
                <span className="save_header_dialog_tittle">Save comps</span>
                <span><CloseIcon data-testid="button-save-comps-close" onClick={() => handleDialog('cancel')}/></span>
            </div>
            <DialogContent classes={{ root: classes.root }}>
                <div className="save-properties">Deal number</div>
                <FormControl classes={{ root: classes.formControlRoot }} variant="outlined" className={classes.formControl}>
                <TextField
                    id="deal-number"
                    inputProps={{ 'data-testid': 'input-deal-number-comps' }}
                    label="Deal number"
                    defaultValue={saveProjectAttrib.dealNumber}
                    variant="outlined"
                    onChange={event => setSaveProjectAttributes({ ...saveProjectAttrib, dealNumber: event.target.value })}
                    />
                </FormControl>
                <div className="save-properties">Office</div>
                <div>
                    <FormControl classes={{ root: classes.formControlRoot }} variant="outlined" className={classes.formControl}>
                            <InputLabel ref={inputLabel} id="region-select-outlined-label">
                                Region
                            </InputLabel>
                            <Select
                            // labelId="demo-simple-select-outlined-label"
                            label="office"
                            id="office-select-outlined"
                            inputProps={{ 'data-testid': 'office-select-outlined' }}
                            value={saveProjectAttrib.office}
                            onChange={event => setSaveProjectAttributes({ ...saveProjectAttrib, office: event.target.value })}
                            labelWidth={10}
                            >
                            {regions && regions.map((region, index) =>
                                <MenuItem key={index} value={region.id}>{region.officeName}</MenuItem>
                            )}
                            </Select>
                    </FormControl>
                </div>
                <FormControl classes={{ root: classes.portfolioformControlRoot }} component="fieldset">
                    <FormLabel component="legend">Portfolio</FormLabel>
                    <RadioGroup aria-label="isPortfolio"
                                name="isPortfolio"
                                onChange={event => setSaveProjectAttributes({ ...saveProjectAttrib, isPortfolio: event.target.value === 'yes' })}
                                value={saveProjectAttrib.isPortfolio ? 'yes' : 'no'} >
                        <FormControlLabel value="yes" control={<Radio inputProps={{ 'data-testid': 'input-portfolio-yes-comps' }}/>} label="Yes"/>
                        <FormControlLabel value="no" control={<Radio inputProps={{ 'data-testid': 'input-portfolio-no-comps' }}/>} label="No" />
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button
                    data-testid="button-save-comps-cancel"
                    onClick={() => handleCancel('cancel')}
                    size="large"
                    id="button-save-comps-cancel"
                >
                    Cancel
              </Button>
                <Button
                    data-testid="button-save-comps-save-download"
                    onClick={() => handleDialog('savedownload', saveProjectAttrib)}
                    size="large"
                    id="button-save-comps-save-download"
                >
                    Save and Download
              </Button>
              <Button
                    data-testid="button-save-comps-save"
                    onClick={() => handleDialog('save', saveProjectAttrib)}
                    size="large"
                    id="button-save-comps-save"
                >
                    Save
              </Button>
            </DialogActions>
        </Dialog>
    )
}

SaveProjectDialog.propTypes = {
    dealNumber: PropTypes.string,
    office: PropTypes.string,
    isPortfolio: PropTypes.bool,
    SaveProjectDialogOpen: PropTypes.bool,
    handleDialog: PropTypes.func,
    regions: PropTypes.array
}

const mapStateToProps = state => ({
    dealNumber: Comps.selectors.comps.dealNumber(state),
    office: Comps.selectors.comps.office(state),
    isPortfolio: Comps.selectors.comps.isPortfolio(state)
  })

  export default connect(
    mapStateToProps,
    null
  )(SaveProjectDialog)
